import $
	from 'jquery';
import Cookies
	from 'js-cookie';
import { isMobile } from 'react-device-detect';

class ManagerHotspot {

	constructor( /*licenseState*/ ) {

		this.hotspots = null;
		// this.licenseState = licenseState;
		this.$pauReactPageVideo = $( "#pauReactPageVideo" );
		this.$pauReactPageAudio = $( "#pauReactPageAudio" );
		this.$pauReactLocucionLSE = $( "#pauReactLocucionLSE" );
		this.videoRender = this.$pauReactPageVideo.get( 0 );
		this.audioRender = this.$pauReactPageAudio.get( 0 );

	}

	/*setLicenseState( status ) {
		this.licenseState = status;
	}*/

	ucFirst( string ) {
		return string.charAt( 0 ).toUpperCase() + string.slice( 1 ).toLowerCase();
	}

	getVideoSources( video ) {

		let videoMp4  = video.mp4 ? `<source type="video/mp4" src="${video.mp4}">` : '',
			videoOgg  = video.ogg ? `<source type="video/ogg" src="${video.ogg}">` : '',
			videoWebm = video.webm ? `<source type="video/webm" src="${video.webm}">` : '';

		return videoMp4 + videoOgg + videoWebm;

	}

	getAudioSources( audio ) {

		let audioMp3 = audio.mp3 ? `<source type="audio/mpeg" src="${audio.mp3}">` : '',
			audioOgg = audio.ogg ? `<source type="audio/ogg" src="${audio.ogg}">` : '';

		return audioMp3 + audioOgg;

	}

	init( hotspots ) {

		this.hotspots = hotspots;

		let $pauMainAcces   = $( "#pauMainAcces" ),
			isAdministrator = Number( $pauMainAcces.attr( "pau-is-administrator" ) ),
			pageID          = $pauMainAcces.attr( "data-paupageid" );

		isAdministrator = Boolean( isAdministrator );

		for ( var i in this.hotspots ) {

			let hotspot          = this.hotspots[ i ],
				{
					id, data_media,
					rute_object, type,
					estado,
					pictograma_name,
					pictograma_url,
					pictograma_url_on,
					pictograma_onclic,
					pictograma_onclic_page,
					pau_onclic_tipo,
					correccion_h,
					correccion_w,
					correccion_x,
					correccion_y,
					position,
					correccion_w_emergent,
					correccion_h_emergent,
					custom_class
				}                = hotspot,
				{ video, audio } = JSON.parse( data_media.replace( /\\/g, "" ) );

			// console.log( typeof hotspot.page );
			// console.log( hotspot.page );
			// console.log( hotspot.page.length );
			// console.log( "--///--" );
			// console.log( typeof pageID );
			// console.log( pageID );
			// console.log( pageID.length );
			// console.log( "------------------------------" );
			// console.log( hotspot );

			let corrections = {
				height          : parseInt( correccion_h, 10 ),
				width           : parseInt( correccion_w, 10 ),
				x               : parseInt( correccion_x, 10 ),
				y               : parseInt( correccion_y, 10 ),
				width_emergent  : parseInt( correccion_w_emergent, 10 ),
				height_emergent : parseInt( correccion_h_emergent, 10 )
			};

			/*if ( !this.licenseState ) {

				if ( id > 15 ) return;

			}*/

			if ( hotspot.page !== "" && hotspot.page !== pageID ) {
				// console.log( "Continue porque no está vacío y no es igual al ID de página\n-- o --\n\n" );
				continue;
			}

			if ( rute_object !== "" ) {

				if (
					estado === "active" ||
					(estado === "pending" && isAdministrator)
				) {

					let $elem = $( rute_object );

					switch ( type ) {

						case "menu" :

							this.typeMenu(
								id, video, audio,
								pictograma_name, pictograma_url, pictograma_url_on,
								pictograma_onclic, pictograma_onclic_page, pau_onclic_tipo,
								$elem, corrections, position,
								custom_class
							);

							break;

						case "emergent" :

							this.typeEmergent(
								id, video, audio,
								pictograma_name, pictograma_url, pictograma_url_on,
								pictograma_onclic, pictograma_onclic_page, pau_onclic_tipo,
								$elem, corrections, position,
								custom_class
							);

							break;

						case "embedded" :

							this.typeEmbedded(
								id, video, audio,
								pictograma_name, pictograma_url, pictograma_url_on,
								pictograma_onclic, pictograma_onclic_page, pau_onclic_tipo,
								$elem, corrections, custom_class
							);

							break;

						case "container" :

							this.typeContainer(
								id, video, audio,
								pictograma_name, pictograma_url, pictograma_url_on,
								pictograma_onclic, pictograma_onclic_page, pau_onclic_tipo,
								$elem, corrections, custom_class
							);

							break;

					}
				}

			} // Fin condicional de rute_object y estado

		} // Fin ciclo for

	}

	typeContainer( id, video, audio,
				   pictograma_name, pictograma_url, pictograma_url_on,
				   pictograma_onclic, pictograma_onclic_page, pau_onclic_tipo,
				   $elem, corrections, custom_class ) {

		let {
				width,
				height,
				x,
				y
			} = corrections;

		width = this.getCorrectionsWH( "width", width );
		height = this.getCorrectionsWH( "height", height );

		let idAudio = `pauAudioHots-${id}`,
			idVideo = `pauVideoHots-${id}`,
			idImg   = `pauImgHots-${id}`,
			idCont  = `pauHotsContainer-${id}`;

		let videoSources = this.getVideoSources( video ),
			audioSources = this.getAudioSources( audio ),
			videoCont    = videoSources !== "" ? `
                <video id="${idVideo}" class="pauHotsContAideo ${custom_class}" loop="true">
                    ${videoSources}Your browser does not support the video tag html5
                </video>` : "",
			audioCont    = audioSources !== "" ? `
                <audio id="${idAudio}" class="pauHotsContAudio">
                    ${audioSources}Your browser does not support the audio tag html5
                </audio>` : "",

			imgTag       = pictograma_url !== "" ? `
                <img id="${idImg}" class="pauPictoHotspot pau-m0" style="${width} ${height}" data-url-cambio-estado="${pictograma_url_on}" src="${pictograma_url}" alt="${pictograma_name}">` : "";

		let container = videoSources === "" && audioSources === "" && imgTag === "" ? "" : `
        <div id="${idCont}" class="pauHotsContainer" style="${width} ${height}">
            ${imgTag}
            ${videoCont}
            ${audioCont}
        </div>
        `;

		if ( this.isTagName( $elem, 'IMG' ) ) {
			$elem
				.addClass( "pauHotsAsigSelect" )
				.after( container );
		} else {
			$elem
				.addClass( "pauHotsAsigSelect" )
				.prepend( container );
		}

		/*
		 * Pictograma OnClic
		 * */

		if ( pau_onclic_tipo === "externo" ) {

			if ( pictograma_onclic_page !== "" ) {

				$elem.on( 'click', function () {

					window.open( pictograma_onclic_page, "_blank" );

				} );

			}

		} else {

			if ( pictograma_onclic !== "" ) {

				$elem.on( 'click', function () {

					window.open( pictograma_onclic_page );

				} );

			}

		}

		let $elemCont = $( `#${idCont}` );

		let actionMouseEnter = e => {

			// e.preventDefault();

			// if( typeof e.touches !== "undefined" && e.touches.length > 1 || ( e.type == "touchend" && e.touches.length > 0 ) )
			//     return;

			let settings = Cookies.getJSON( "settings" ),
				{
					geral_todo,
					geral_sonido,
					geral_video
				}        = settings;

			let $elemImg = $( "#" + idImg );

			if ( imgTag !== "" ) {

				let srcOn  = $elemImg.attr( "data-url-cambio-estado" ),
					srcOff = $elemImg.attr( "src" );

				if ( srcOn !== "" && srcOff !== "" ) {
					$elemImg.attr( "src", srcOn );
					$elemImg.attr( "data-url-cambio-estado", srcOff );
				}

			}

			if ( !geral_todo.value ) return;

			let $elemVideo = $( "#" + idVideo ).get( 0 ),
				$elemAudio = $( "#" + idAudio ).get( 0 );

			$( "#" + idVideo ).show();

			if ( videoSources !== "" && geral_video.value ) {

				this.thenCatchAutoplay( {
					elem : $elemVideo
				} );

			}

			if ( audioSources !== "" && geral_sonido.value ) {

				this.thenCatchAutoplay( {
					elem : $elemAudio
				} );

			}

			if ( !this.videoRender.ended ) this.videoRender.pause();
			if ( !this.audioRender.ended ) this.audioRender.pause();

		};

		let actionMouseLeave = e => {

			// e.preventDefault();

			let settings                                                 = Cookies.getJSON( "settings" ),
				{ geral_todo, geral_sonido, geral_video, geral_lectura } = settings;

			let $elemImg = $( "#" + idImg );

			if ( imgTag !== "" ) {

				let srcOn  = $elemImg.attr( "src" ),
					srcOff = $elemImg.attr( "data-url-cambio-estado" );

				if ( srcOn !== "" && srcOff !== "" ) {
					$elemImg.attr( "src", srcOff );
					$elemImg.attr( "data-url-cambio-estado", srcOn );
				}

			}

			if ( !geral_todo.value ) return;

			let $elemVideo = $( "#" + idVideo ).get( 0 ),
				$elemAudio = $( "#" + idAudio ).get( 0 );

			$( "#" + idVideo ).hide();

			if ( !geral_lectura.value ) return;

			if ( videoSources !== "" && geral_video.value ) {

				$elemVideo.pause();
				$elemVideo.currentTime = 0;

				if ( !this.videoRender.ended ) {

					this.thenCatchAutoplay( {
						elem : this.videoRender
					} );

				}

			}

			if ( audioSources !== "" && geral_sonido.value ) {

				$elemAudio.pause();
				$elemAudio.currentTime = 0;

				if ( !this.audioRender.ended ) {

					this.thenCatchAutoplay( {
						elem : this.audioRender
					} );

				}

			}

		};

		if ( videoSources === "" ) $elemCont.removeClass( "pauHotsContainer" );

		let eventInside = "mouseenter",
			eventOut    = "mouseleave";

		if ( isMobile ) {

			eventInside = "touchstart";
			eventOut = "touchend";

			$elem.on( 'contextmenu', e => {
				return false;
			} );

		}

		$elem.on( eventInside, actionMouseEnter );
		$elem.on( eventOut, actionMouseLeave );

	}

	typeEmbedded( id, video, audio,
				  pictograma_name, pictograma_url, pictograma_url_on,
				  pictograma_onclic, pictograma_onclic_page, pau_onclic_tipo,
				  $elem, corrections, custom_class ) {

		let {
				width,
				height,
				x,
				y
			} = corrections;

		width = this.getCorrectionsWH( "width", width );
		height = this.getCorrectionsWH( "height", height );

		let idAudio = `pauAudioHots-${id}`,
			idVideo = `pauVideoHots-${id}`,
			idImg   = `pauImgHots-${id}`,
			idCont  = `pauHotsContainer-${id}`;

		let videoSources = this.getVideoSources( video ),
			audioSources = this.getAudioSources( audio ),
			videoCont    = videoSources !== "" ? `
                <video id="${idVideo}" class="pauHotsContAideo ${custom_class}" loop="true">
                    ${videoSources}Your browser does not support the video tag html5
                </video>` : "",
			audioCont    = audioSources !== "" ? `
                <audio id="${idAudio}" class="pauHotsContAudio">
                    ${audioSources}Your browser does not support the audio tag html5
                </audio>` : "",

			imgTag       = pictograma_url !== "" ? `
                <img id="${idImg}" class="pauPictoHotspot pau-m0" style="${width} ${height}" data-url-cambio-estado="${pictograma_url_on}" src="${pictograma_url}" alt="${pictograma_name}">` : "";

		let container = videoSources === "" && audioSources === "" && imgTag === "" ? "" : `
        <div id="${idCont}" class="pauHotsContainer" style="${width} ${height}">
            ${imgTag}
            ${videoCont}
            ${audioCont}
        </div>
        `;

		if ( this.isTagName( $elem, 'IMG' ) ) {
			$elem
				.addClass( "pauHotsAsigSelect" )
				.after( container );
		} else {
			$elem
				.addClass( "pauHotsAsigSelect" )
				.prepend( container );
		}

		/*
		 * Pictograma OnClic
		 * */

		if ( pau_onclic_tipo === "externo" ) {

			if ( pictograma_onclic_page !== "" ) {

				$elem.on( 'click', function () {

					window.open( pictograma_onclic_page, "_blank" );

				} );

			}

		} else {

			if ( pictograma_onclic !== "" ) {

				$elem.on( 'click', function () {

					window.open( pictograma_onclic_page );

				} );

			}

		}

		let $elemCont = $( `#${idCont}` );

		let actionMouseEnter = e => {

			// e.preventDefault();

			// if( typeof e.touches !== "undefined" && e.touches.length > 1 || ( e.type == "touchend" && e.touches.length > 0 ) )
			//     return;

			let settings = Cookies.getJSON( "settings" ),
				{
					geral_todo,
					geral_sonido,
					geral_video
				}        = settings;

			let $elemImg = $( "#" + idImg );

			if ( imgTag !== "" ) {

				let srcOn  = $elemImg.attr( "data-url-cambio-estado" ),
					srcOff = $elemImg.attr( "src" );

				if ( srcOn !== "" && srcOff !== "" ) {
					$elemImg.attr( "src", srcOn );
					$elemImg.attr( "data-url-cambio-estado", srcOff );
				}

			}

			if ( !geral_todo.value ) return;

			let $elemVideo = $( "#" + idVideo ).get( 0 ),
				$elemAudio = $( "#" + idAudio ).get( 0 );

			$( "#" + idVideo ).show();

			if ( videoSources !== "" && geral_video.value ) {

				this.thenCatchAutoplay( {
					elem : $elemVideo
				} );

			}

			if ( audioSources !== "" && geral_sonido.value ) {

				this.thenCatchAutoplay( {
					elem : $elemAudio
				} );

			}

			if ( !this.videoRender.ended ) this.videoRender.pause();
			if ( !this.audioRender.ended ) this.audioRender.pause();

		};

		let actionMouseLeave = e => {

			// e.preventDefault();

			let settings                                                 = Cookies.getJSON( "settings" ),
				{ geral_todo, geral_sonido, geral_video, geral_lectura } = settings;

			let $elemImg = $( "#" + idImg );

			if ( imgTag !== "" ) {

				let srcOn  = $elemImg.attr( "src" ),
					srcOff = $elemImg.attr( "data-url-cambio-estado" );

				if ( srcOn !== "" && srcOff !== "" ) {
					$elemImg.attr( "src", srcOff );
					$elemImg.attr( "data-url-cambio-estado", srcOn );
				}

			}

			if ( !geral_todo.value ) return;

			let $elemVideo = $( "#" + idVideo ).get( 0 ),
				$elemAudio = $( "#" + idAudio ).get( 0 );

			$( "#" + idVideo ).hide();

			if ( !geral_lectura.value ) return;

			if ( videoSources !== "" && geral_video.value ) {

				$elemVideo.pause();
				$elemVideo.currentTime = 0;

				if ( !this.videoRender.ended ) {

					this.thenCatchAutoplay( {
						elem : this.videoRender
					} );

				}

			}

			if ( audioSources !== "" && geral_sonido.value ) {

				$elemAudio.pause();
				$elemAudio.currentTime = 0;

				if ( !this.audioRender.ended ) {

					this.thenCatchAutoplay( {
						elem : this.audioRender
					} );

				}

			}

		};

		if ( videoSources === "" ) $elemCont.removeClass( "pauHotsContainer" );

		let eventInside = "mouseenter",
			eventOut    = "mouseleave";

		if ( isMobile ) {

			eventInside = "touchstart";
			eventOut = "touchend";

			$elem.on( 'contextmenu', e => {
				return false;
			} );

		}

		$elem.on( eventInside, actionMouseEnter );
		$elem.on( eventOut, actionMouseLeave );

	}

	typeMenu( id, video, audio,
			  pictograma_name, pictograma_url, pictograma_url_on,
			  pictograma_onclic, pictograma_onclic_page, pau_onclic_tipo,
			  $elem, corrections, position,
			  custom_class ) {

		let {
				width,
				height,
				x,
				y,
				width_emergent,
				height_emergent
			} = corrections;

		width = this.getCorrectionsWH( "width", width );
		height = this.getCorrectionsWH( "height", height );

		width_emergent = this.getCorrectionsWH( "width", width_emergent );
		height_emergent = this.getCorrectionsWH( "height", height_emergent );

		let idAudio = `pauAudioHots-${id}`,
			idVideo = `pauVideoHots-${id}`,
			idImg   = `pauImgHots-${id}`;

		let videoSources = this.getVideoSources( video ),
			audioSources = this.getAudioSources( audio ),

			videoTag     = videoSources !== "" ? `
                <video id="${idVideo}" class="pau-videos video-desactivado ${custom_class}" style="${width_emergent} ${height_emergent}" loop="true">
                    ${videoSources}Your browser does not support the video tag html5
                </video>` : "",

			audioTag     = audioSources !== "" ? `
                <audio id="${idAudio}" class="pau-audios audio-desactivado">
                    ${audioSources}Your browser does not support the audio tag html5
                </audio>` : "",

			imgTag       = pictograma_url !== "" ? `
                <img id="${idImg}" class="pauPictoHotspot" style="${width} ${height}" data-url-cambio-estado="${pictograma_url_on}" src="${pictograma_url}" alt="${pictograma_name}">` : "";

		let typeContainer = this.getTypeContainer( {
			id,
			type : 'menu',
			vals : videoTag + audioTag + imgTag
		} );

		if ( position !== "none" ) {

			let clase = `pauHotSpot${this.ucFirst( position )}`;

			$elem.css( {
				"position"    : 'relative',
				"display"     : 'flex',
				"align-items" : 'center',
			} ).addClass( clase );

		}

		/*
		 * Pictograma OnClic
		 * */

		if ( pau_onclic_tipo === "externo" ) {

			if ( pictograma_onclic_page !== "" ) {

				$elem.on( 'click', function () {

					window.open( pictograma_onclic_page, "_blank" );

				} );

			}

		} else {

			if ( pictograma_onclic !== "" ) {

				$elem.on( 'click', function () {

					window.open( pictograma_onclic_page );

				} );

			}

		}

		if ( this.isTagName( $elem, 'IMG' ) ) {
			$elem.after( typeContainer );
		} else {
			$elem
				.prepend( typeContainer )
				.css( "position", "relative" );
		}

		let eventInside = "mouseenter",
			eventOut    = "mouseleave";

		if ( isMobile ) {

			eventInside = "touchstart";
			eventOut = "touchend";

			$elem.on( 'contextmenu', e => {
				return false;
			} );

		}

		$elem.on( eventInside, ( e ) => {

			// e.preventDefault();

			// if( typeof e.touches !== "undefined" && e.touches.length > 1 || ( e.type == "touchend" && e.touches.length > 0 ) )
			//     return;

			let pos = e.target.getBoundingClientRect();

			let settings = Cookies.getJSON( "settings" ),
				{
					geral_todo,
					geral_sonido,
					geral_video
				}        = settings;

			if ( !geral_todo.value ) return;

			let $elemVideo = $( "#" + idVideo ),
				$elemAudio = $( "#" + idAudio ),
				$elemImg   = $( "#" + idImg );

			/**
			 * Verificando que estos valores
			 * no sean números para asignarles un valor por defecto
			 * y no genere error en el cálculo
			 */
			if ( isNaN( x ) ) {
				x = 0;
			}
			if ( isNaN( y ) ) {
				y = 0;
			}

			if ( videoSources !== "" && geral_video.value ) {

				$elemVideo.css( "left", x + 'em' );
				$elemVideo.css( "top", y + 'em' );

				$elemVideo
					.addClass( "video-activado" )
					.removeClass( "video-desactivado" );

				this.thenCatchAutoplay( {
					elem : $elemVideo.get( 0 )
				} );

				if ( !this.videoRender.ended ) this.videoRender.pause();

			}

			if ( audioSources !== "" && geral_sonido.value ) {

				$elemAudio
					.addClass( "audio-activado" )
					.removeClass( "audio-desactivado" );

				this.thenCatchAutoplay( {
					elem : $elemAudio.get( 0 )
				} );

				if ( !this.audioRender.ended ) this.audioRender.pause();

			}

			if ( imgTag !== "" ) {

				let srcOn  = $elemImg.attr( "data-url-cambio-estado" ),
					srcOff = $elemImg.attr( "src" );

				if ( srcOn !== "" && srcOff !== "" ) {
					$elemImg.attr( "src", srcOn );
					$elemImg.attr( "data-url-cambio-estado", srcOff );
				}

			}

		} );

		$elem.on( eventOut, ( e ) => {

			// e.preventDefault();

			let settings = Cookies.getJSON( "settings" ),
				{
					geral_todo,
					geral_sonido,
					geral_video
				}        = settings;

			if ( !geral_todo.value ) return;

			let $elemVideo = $( "#" + idVideo ),
				$elemAudio = $( "#" + idAudio ),
				$elemImg   = $( "#" + idImg );

			if ( imgTag !== "" ) {

				let srcOn  = $elemImg.attr( "src" ),
					srcOff = $elemImg.attr( "data-url-cambio-estado" );

				if ( srcOn !== "" && srcOff !== "" ) {
					$elemImg.attr( "src", srcOff );
					$elemImg.attr( "data-url-cambio-estado", srcOn );
				}

			}

			if ( videoSources !== "" && geral_video.value ) {

				$elemVideo
					.removeClass( "video-activado" )
					.addClass( "video-desactivado" )
					.get( 0 ).pause();

				$elemVideo.get( 0 ).currentTime = 0;

				if ( !this.videoRender.ended ) {

					this.thenCatchAutoplay( {
						elem : this.videoRender
					} );

				}

			}

			if ( audioSources !== "" && geral_sonido.value ) {

				$elemAudio
					.removeClass( "audio-activado" )
					.addClass( "audio-desactivado" )
					.get( 0 ).pause();

				$elemAudio.get( 0 ).currentTime = 0;

				if ( !this.audioRender.ended ) {

					this.thenCatchAutoplay( {
						elem : this.audioRender
					} );

				}

			}

		} );

	}

	typeEmergent( id, video, audio,
				  pictograma_name, pictograma_url, pictograma_url_on,
				  pictograma_onclic, pictograma_onclic_page, pau_onclic_tipo,
				  $elem, corrections, position,
				  custom_class ) {

		let {
				width,
				height,
				x,
				y,
				width_emergent,
				height_emergent
			} = corrections;

		width = this.getCorrectionsWH( "width", width, 'img' );
		height = this.getCorrectionsWH( "height", height, 'img' );
		width_emergent = this.getCorrectionsWH( "width", width_emergent, 'video' );
		height_emergent = this.getCorrectionsWH( "height", height_emergent, 'video' );

		let idAudio = `pauAudioHots-${id}`,
			idVideo = `pauVideoHots-${id}`,
			idImg   = `pauImgHots-${id}`;

		let videoSources = this.getVideoSources( video ),
			audioSources = this.getAudioSources( audio ),

			videoTag     = videoSources !== "" ? `
                <video id="${idVideo}" class="pau-videos video-desactivado ${custom_class}" style="${width_emergent} ${height_emergent}" loop="true">
                    ${videoSources}Your browser does not support the video tag html5
                </video>` : "",

			audioTag     = audioSources !== "" ? `
                <audio id="${idAudio}" class="pau-audios audio-desactivado">
                    ${audioSources}Your browser does not support the audio tag html5
                </audio>` : "",

			imgTag       = pictograma_url !== "" ? `
                <img id="${idImg}" class="pauPictoHotspot" style="${width} ${height}" data-url-cambio-estado="${pictograma_url_on}" src="${pictograma_url}" alt="${pictograma_name}">` : "";

		let typeContainer = this.getTypeContainer( {
			id,
			type : 'menu',
			vals : videoTag + audioTag + imgTag
		} );

		if ( position !== "none" ) {

			let clase = `pauHotSpot${this.ucFirst( position )}`;

			$elem.css( {
				"position"    : 'relative',
				"display"     : 'flex',
				"align-items" : 'center',
			} ).addClass( clase );

		}

		/*
		 * Pictograma OnClic
		 * */

		if ( pau_onclic_tipo === "externo" ) {

			if ( pictograma_onclic_page !== "" ) {

				$elem.on( 'click', function () {

					window.open( pictograma_onclic_page, "_blank" );

				} );

			}

		} else {

			if ( pictograma_onclic !== "" ) {

				$elem.on( 'click', function () {

					window.open( pictograma_onclic_page );

				} );

			}

		}

		if ( this.isTagName( $elem, 'IMG' ) ) {
			$elem.after( typeContainer );
		} else {
			$elem
				.prepend( typeContainer )
				.css( "position", "relative" );
		}

		let eventInside = "mouseenter",
			eventOut    = "mouseleave";

		if ( isMobile ) {

			eventInside = "touchstart";
			eventOut = "touchend";

			$elem.on( 'contextmenu', e => {
				return false;
			} );

		}

		$elem.on( eventInside, ( e ) => {

			// e.preventDefault();

			// if( typeof e.touches !== "undefined" && e.touches.length > 1 || ( e.type == "touchend" && e.touches.length > 0 ) )
			//     return;

			let pos = e.target.getBoundingClientRect();

			let settings                                  = Cookies.getJSON( "settings" ),
				{ geral_todo, geral_sonido, geral_video } = settings;

			if ( !geral_todo.value ) return;

			let $elemVideo = $( "#" + idVideo ),
				$elemAudio = $( "#" + idAudio ),
				$elemImg   = $( "#" + idImg );

			/**
			 * Verificando que estos valores
			 * no sean números para asignarles un valor por defecto
			 * y no genere error en el cálculo
			 */
			if ( isNaN( x ) ) {
				x = 0;
			}
			if ( isNaN( y ) ) {
				y = 0;
			}

			if ( videoSources !== "" && geral_video.value ) {

				$elemVideo.css( "left", x );
				$elemVideo.css( "top", y );

				$elemVideo
					.addClass( "video-activado" )
					.removeClass( "video-desactivado" );

				this.thenCatchAutoplay( {
					elem : $elemVideo.get( 0 )
				} );

				if ( !this.videoRender.ended ) this.videoRender.pause();

			}

			if ( audioSources !== "" && geral_sonido.value ) {

				$elemAudio
					.addClass( "audio-activado" )
					.removeClass( "audio-desactivado" );

				this.thenCatchAutoplay( {
					elem : $elemAudio.get( 0 )
				} );

				if ( !this.audioRender.ended ) this.audioRender.pause();

			}

			if ( imgTag !== "" ) {

				let srcOn  = $elemImg.attr( "data-url-cambio-estado" ),
					srcOff = $elemImg.attr( "src" );

				if ( srcOn !== "" && srcOff !== "" ) {
					$elemImg.attr( "src", srcOn );
					$elemImg.attr( "data-url-cambio-estado", srcOff );
				}

			}

		} );

		$elem.on( eventOut, ( e ) => {

			// e.preventDefault();

			let settings                                                 = Cookies.getJSON( "settings" ),
				{ geral_todo, geral_sonido, geral_video, geral_lectura } = settings;

			if ( !geral_todo.value ) return;

			let $elemVideo = $( "#" + idVideo ),
				$elemAudio = $( "#" + idAudio ),
				$elemImg   = $( "#" + idImg );

			if ( imgTag !== "" ) {

				let srcOn  = $elemImg.attr( "src" ),
					srcOff = $elemImg.attr( "data-url-cambio-estado" );

				if ( srcOn !== "" && srcOff !== "" ) {
					$elemImg.attr( "src", srcOff );
					$elemImg.attr( "data-url-cambio-estado", srcOn );
				}

			}

			if ( videoSources !== "" && geral_video.value ) {

				$elemVideo
					.removeClass( "video-activado" )
					.addClass( "video-desactivado" )
					.get( 0 ).pause();

				$elemVideo.get( 0 ).currentTime = 0;

				if ( !this.videoRender.ended ) {

					this.thenCatchAutoplay( {
						elem : this.videoRender
					} );

				}

			}

			if ( audioSources !== "" && geral_sonido.value ) {

				$elemAudio
					.removeClass( "audio-activado" )
					.addClass( "audio-desactivado" )
					.get( 0 ).pause();

				$elemAudio.get( 0 ).currentTime = 0;

				if ( !this.audioRender.ended ) {

					this.thenCatchAutoplay( {
						elem : this.audioRender
					} );

				}

			}

		} );

	}

	isTagName( $elem, tag ) {
		return $elem.prop( 'tagName' ) === tag;
	}

	getTypeContainer( { id = "", type = 'menu', vals = '' } ) {
		return `<div class="pau-container-${type} pau-container-${type}-${id}">
					${vals}
				</div>`;
	}

	typePageContent( hotspot ) {

		let {
				// id,
				// rute_object, type,
				// estado,
				// pictograma_name,
				// pictograma_url,
				// pictograma_url_on
				data_media
			}                = hotspot,
			{ video, audio } = JSON.parse( data_media.replace( /\\/g, "" ) );

		this.$pauReactPageVideo
			.html( `${this.getVideoSources( video )}` );

		this.$pauReactPageAudio
			.html( `${this.getVideoSources( audio )}` );

		this.videoRender.load();
		this.audioRender.load();

		let settings                                                 = Cookies.getJSON( "settings" ),
			{ geral_todo, geral_lectura, geral_sonido, geral_video } = settings;

		if ( !geral_todo.value ) return;
		if ( !geral_lectura.value ) return;

		if ( geral_video.value ) {

			let $reactLocuLSE = this.$pauReactLocucionLSE;

			this.thenCatchAutoplay( {
				elem    : this.videoRender,
				success : _ => {
					$reactLocuLSE.show();
				},
				fail    : error => {

					this.clickStateForAutoplay( {
						video    : this.videoRender,
						audio    : this.audioRender,
						callback : _ => {
							$reactLocuLSE.show();
						}
					} );

				}
			} );

			// let videoRender = this.videoRender.play();
			//
			// if( videoRender !== undefined ) {
			//
			//     videoRender.then( _ => {
			//         this.$pauReactLocucionLSE.show();
			//     }).catch( error => {
			//
			//         let reactLocu = this.$pauReactLocucionLSE;
			//
			//         console.log( error );
			//
			//         this.clickStateForAutoplay( this.videoRender, this.audioRender, function() {
			//             reactLocu.show();
			//         });
			//
			//     });
			//
			// }

		}

		if ( geral_sonido.value ) {

			this.thenCatchAutoplay( {
				elem : this.audioRender
			} );

		}

		/*this.$pauReactPageVideo.on( "ended", ( e ) => {
		 if( this.audioRender.ended ) {
		 this.pauFullScreenCancel( this.videoRender );
		 this.$pauReactLocucionLSE.fadeOut();
		 }
		 });

		 this.$pauReactPageVideo.on( "ended", ( e ) => {
		 if( this.videoRender.ended ) {
		 this.pauFullScreenCancel( this.videoRender );
		 this.$pauReactLocucionLSE.fadeOut();
		 }
		 });*/

		// Acciones de los botones para el contenedor
		// de video de página

		let $pauReactPlayVideo        = $( "#pauReactPlayVideo" ),
			$pauReactPantallaCompleta = $( "#pauReactPantallaCompleta" ),
			$pauReactCierraVideo      = $( "#pauReactCierraVideo" );

		$pauReactPantallaCompleta.on( "click", () => {

			this.pauFullScreen( this.videoRender );

		} );

		$pauReactPlayVideo.on( "click", () => {
			this.pauVideoPlayPause( this.audioRender, this.videoRender, $pauReactPlayVideo );
		} );

		$pauReactCierraVideo.on( "click", () => {

			this.$pauReactLocucionLSE.hide();
			this.videoRender.pause();
			this.videoRender.currentTime = 0;

		} );

	}

	getCorrectionsWH( tag, val ) {

		return val !== "" && val > 0 && $.isNumeric( val ) ? `${tag}: ${val}em!important; max-${tag}: ${val}em!important;` : "";

	}

	pauVideoPlayPause( audio, video, btn ) {

		if ( audio.paused && video.paused ) {
			audio.play();
			video.play();
			btn.html( "||" );
		} else {
			audio.pause();
			video.pause();
			btn.html( ">" );
		}

	}

	pauFullScreen( elem ) {

		if ( elem.requestFullScreen ) {
			elem.requestFullScreen();
		} else if ( elem.webkitRequestFullScreen ) {
			elem.webkitRequestFullScreen();
		} else if ( elem.mozRequestFullScreen ) {
			elem.mozRequestFullScreen();
		} else if ( elem.msRequestFullscreen ) {
			elem.msRequestFullscreen();
		}

	}

	pauFullScreenCancel( elem ) {

		if ( document.exitFullScreen ) {
			document.exitFullScreen();
		} else if ( document.webkitExitFullscreen ) {
			document.webkitExitFullscreen();
		} else if ( document.mozCancelFullScreen ) {
			document.mozCancelFullScreen();
		} else if ( document.msExitFullscreen ) {
			document.msExitFullscreen();
		}

	}

	thenCatchAutoplay( { elem, success = null, fail = null } ) {

		let promise = elem.play();

		if ( promise !== undefined ) {

			promise.then( _ => {

				if ( success && typeof success === "function" ) success();

			} ).catch( error => {

				if ( fail && typeof fail === "function" ) fail( error );

			} );

		}

	}

	clickStateForAutoplay( { video = null, audio = null, callback = null } ) {

		let settings         = Cookies.getJSON( "settings" ),
			{ geral_sonido } = settings;

		let count = 1;

		$( "*" ).on( "click", ( e ) => {

			if ( count !== 1 ) return;

			count++;

			if ( video ) {

				let videoRender = video.play();

				if ( videoRender !== undefined ) {

					videoRender.then( _ => {

						if ( callback && typeof callback === "function" ) callback();

					} ).catch( error => {
						// if( fail && typeof fail === "function" ) fail();
					} );

				}

			}

			if ( audio ) {

				if ( geral_sonido.value ) {

					let audioRender = audio.play();

					if ( audioRender !== undefined ) {

						audioRender.then( _ => {

						} ).catch( error => {
							console.log( error );
						} );

					}

				}

			}

		} );

	}

}

// const managerHotspot = new ManagerHotspot();

export default ManagerHotspot;



// WEBPACK FOOTER //
// ./src/includes/ManagerHotspot.js